import React from 'react';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';
import {
  formatCpfMask,
  formatTelefoneMask,
  isValidEmail,
} from 'utils/signatureFieldModel';

const SignatureFieldFormPanel = ({
  field,
  onChange,
  onConfirm,
  onCancel,
  emailError,
}) => {
  if (!field) return null;

  const emailRaw = String(field.email || '').trim();
  const emailInvalid = Boolean(emailRaw && !isValidEmail(field.email));

  return (
    <div className="rounded-lg border border-primary/20 bg-card p-4 space-y-3 shadow-sm">
      <h3 className="text-sm font-semibold text-foreground">
        {field.isConfirmed ? 'Editar signatário' : 'Dados do signatário'}
      </h3>

      <Input
        label="Nome completo"
        required
        value={field.full_name}
        onChange={(e) => onChange('full_name', e.target.value)}
        placeholder="Nome completo"
      />

      <Input
        label="E-mail"
        type="email"
        value={field.email}
        onChange={(e) => onChange('email', e.target.value)}
        placeholder="email@dominio.com"
        description="Obrigatório se o envio for via E-mail"
        error={emailError || (emailInvalid ? 'E-mail inválido' : undefined)}
      />

      <Input
        label="Telefone (WhatsApp)"
        type="tel"
        value={field.telefone || ''}
        onChange={(e) => onChange('telefone', formatTelefoneMask(e.target.value))}
        placeholder="(48) 99999-0000"
        description="Obrigatório se o envio for via WhatsApp"
      />

      <Input
        label="CPF"
        value={field.cpf || ''}
        onChange={(e) => onChange('cpf', formatCpfMask(e.target.value))}
        placeholder="000.000.000-00"
        description="Opcional"
      />

      <div className="flex flex-col gap-2 pt-1 sm:flex-row sm:justify-end">
        <Button
          type="button"
          onClick={onConfirm}
          fullWidth
          className="sm:w-auto sm:min-w-[7.5rem]"
          disabled={!String(field.full_name || '').trim() || emailInvalid}
        >
          {field.isConfirmed ? 'Atualizar' : 'Confirmar'}
        </Button>
        {field.isDraft && !field.isConfirmed && (
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            fullWidth
            className="sm:w-auto"
          >
            Descartar
          </Button>
        )}
      </div>
    </div>
  );
};

export default SignatureFieldFormPanel;
